import * as cls from 'classnames';
import * as React from 'react';
import * as Media from "react-media";
import { AddItem } from './AddItem';
import { Item } from './Item';
import * as Config from '../../../configuration/consts';
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import SortableListItem from "../../Controls/SortableListItem";


export type ResourceListProps = {
    activeFilter: any,
    currentUser: any,
    filter: any,
    forum: any,
    userRole: any;
}

export type ResourceListActions = {
    addResourceTag: Function,
    clearResource: Function,
    editResource: Function,
    flagResource: Function,
    saveResource: Function,
    sortResourceItem: Function;
}

export type ResourceListPropsAndActions = ResourceListProps & ResourceListActions;

export type ResourceListState = {
    dragSource: any;
    hoverIndex: any,
    showAddItem: boolean;
    showMessage: any
}

class ResourceList extends React.Component<ResourceListPropsAndActions, ResourceListState> {
    constructor(props: ResourceListPropsAndActions) {
        super(props);
        this.state = {
            showMessage: !this.props.filter,
            hoverIndex: undefined,
            dragSource: undefined,
            showAddItem: false,
        }
        this.onHideMessage = this.onHideMessage.bind(this);
        this.moveListItem = this.moveListItem.bind(this);
        this.onDropped = this.onDropped.bind(this);
        this.onBeginDrag = this.onBeginDrag.bind(this);
        this.onPostToggleClicked = this.onPostToggleClicked.bind(this);
        this.moveItem = this.moveItem.bind(this);
    }
    onBeginDrag(dragSource) {
        this.setState({dragSource: dragSource});
    }
    onDropped(){
        this.props.sortResourceItem(this.props.forum.id, this.state.dragSource.id, this.state.hoverIndex);
        this.setState({hoverIndex: undefined, dragSource: undefined});
    }

    onPostToggleClicked() {
        this.setState({ showAddItem: !this.state.showAddItem });
    }

    moveListItem(dragIndex, hoverIndex) {
        this.setState({hoverIndex: hoverIndex});
    }

    onHideMessage() {
        this.setState({ showMessage: false });
    }
    moveItem(itemId, idx) {
        this.props.sortResourceItem(this.props.forum.id, itemId, idx);
    }

    render() {

        const {  userRole, currentUser, forum, activeFilter, saveResource, editResource, flagResource, clearResource, ...props } = this.props;

        let isAdmin = userRole == Config.ROLE_ADMIN;
        let dragSourceId = this.state.dragSource ? this.state.dragSource.id : undefined;
        let content = forum.resources.map((item, index) => {
            return !activeFilter || !activeFilter.id || item.tags.find(i => i.id === activeFilter.id) ?
                <SortableListItem
                    key={`resourceItem[${index}]`}
                    index={index}
                    id={item.id}
                    moveListItem={this.moveListItem}
                    onDropped={this.onDropped}
                    onBeginDrag={this.onBeginDrag}
                    active={isAdmin}
                >
                    <Item key={"ri" + index} userRole={userRole} currentUser={currentUser} forum={forum}
                        editResource={editResource} flagResource={flagResource} activeFilter={activeFilter}
                        addResourceTag={this.props.addResourceTag}
                        {...item}
                        active={dragSourceId === item.id}
                        moveItem={this.moveItem}
                        totalResources={this.props.forum && this.props.forum.resources ? this.props.forum.resources.length : 0}>
                        {this.state.hoverIndex === index ? <div style={{ borderTop: "2px solid black" }} /> : undefined}
                    </Item>

                </SortableListItem> : undefined;
        });

        let message = forum.defaultResourceMessage ? <div className="alert alert-default">{forum.defaultResourceMessage}</div> : undefined;
        let addNewResource = isAdmin ?
            this.state.showAddItem ?
                <AddItem saveResource={saveResource}
                    clearResource={() => { clearResource(); this.onPostToggleClicked(); }}
                    activeFilter={activeFilter}
                    forum={forum}
                    resource={forum.editingResource} /> :
                <div className="btn btn-primary btn-block clickable" onClick={this.onPostToggleClicked}>CREATE NEW RESOURCE</div>
            : undefined;

        return (
            <Media query="(max-width: 1023px)">
                {
                    matches => {
                        return <div className="col-12 col-md-7">
                            {message}
                            {addNewResource}
                            <div className={cls("discussion-board-resource fixed-scrolling", "mt-2", { "overflow": !matches })}>
                                <div className="row ">
                                    <div className="col-4 col-md-6">
                                        <strong>TITLE</strong>
                                    </div>
                                    <div className="col-3 col-md-3">
                                        <strong>AUTHOR</strong>
                                    </div>
                                    <div className="col-2 col-md-1">
                                        <strong>YEAR</strong>
                                    </div>
                                </div>
                                <div className="scrolling-y">
                                    {content}
                                </div>
                            </div>
                        </div>
                    }
                }
            </Media>);
        /*return (<div className="col-12 col-md-9">
            {message}
            {addNewResource}
            <div className="discussion-board-resource">
                <div className="row ">
                    <div className="col-4 col-md-6">
                        <strong>TITLE</strong>
                    </div>
                    <div className="col-3 col-md-3">
                        <strong>AUTHOR</strong>
                    </div>
                    <div className="col-2 col-md-1">
                        <strong>YEAR</strong>
                    </div>
                </div>
                {content}
            </div>
        </div>);*/
    }
}


export default DragDropContext(HTML5Backend)(ResourceList);


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Resources/List.tsx